<template>
    <div>
        <!-- Modal Alterar Local de Armazenagem -->
        <div class="modal fade" id="alterarLocalModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="solic">
                    <div class="modal-header">
                        <h5 class="modal-title">Alterar Local de Armazenagem</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">
                            #{{ solic.id_estoque_solicitacao }}
                        </div>

                        <az-input
                            label="Local de Armazenagem"
                            placeholder="Selecione o Local..."
                            type="select"
                            service="estoque_locals.index"
                            optionsData="id_estoque_local"
                            optionsMode="aql"
                            optionsName="estoque_locals.index.sup"
                            :optionsParm="{ sup: 1 }"
                            required
                            :validate="validate"
                            v-model="solic.id_estoque_local" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar_local()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Alterar Centro de Custo -->
        <div class="modal fade" id="alterarCentroModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="solic">
                    <div class="modal-header">
                        <h5 class="modal-title">Alterar Centro de Custo</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">
                            #{{ solic.id_estoque_solicitacao }}
                        </div>

                        <az-input
                            label="Centro de Custo"
                            type="autocomplete"
                            placeholder="Selecione o Centro de Custo..."
                            service="centro_custos.index"
                            optionsData="id_centro_custo"
                            v-model="solic.id_centro_custo">
                        </az-input>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar_centro()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Alterar Data -->
        <div class="modal fade" id="alterarDataModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="solic">
                    <div class="modal-header">
                        <h5 class="modal-title">Alterar Centro de Custo</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">
                            #{{ solic.id_estoque_solicitacao }}
                        </div>

                        <az-input
                            label="Data"
                            type="datetime-local"
                            v-model="solic.dt_solicitacao">
                        </az-input>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar_data()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash'; 
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return { 
            solic: null, 
            validate: true, 
        }
    },
    
    components: { 
        AzInput, 
        AzSubmit, 
    },

    methods: { 
        alterar_data (solic) { 
            this.validate = false; 
            this.solic = null; 

            this.$nextTick(() => { 
                this.solic = _.cloneDeep(solic);
                $('#alterarDataModal').modal('show');
            });
        },

        atualizar_data () { 
            this.$util.atualizar(this, { 
                service: 'estoque_solicitacoes', 
                func: 'store',
                dados: { 
                    id_estoque_solicitacao: this.solic.id_estoque_solicitacao, 
                    dt_solicitacao: this.solic.dt_solicitacao
                }, 
                toast: true, 
                modal: 'alterarDataModal', 
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        }, 

        //

        //

        alterar_local (solic) { 
            this.validate = false; 
            this.solic = null; 

            this.$nextTick(() => { 
                this.solic = _.cloneDeep(solic);
                $('#alterarLocalModal').modal('show');
            });
        },

        atualizar_local () { 
            this.$util.atualizar(this, { 
                service: 'estoque_solicitacoes', 
                func: 'store',
                dados: { 
                    id_estoque_solicitacao: this.solic.id_estoque_solicitacao, 
                    id_estoque_local: this.solic.id_estoque_local
                }, 
                toast: true, 
                modal: 'alterarLocalModal', 
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        }, 

        //

        alterar_centro (solic) { 
            this.validate = false; 
            this.solic = null; 

            this.$nextTick(() => { 
                this.solic = _.cloneDeep(solic);
                $('#alterarCentroModal').modal('show');
            });
        },

        atualizar_centro () { 
            this.$util.atualizar(this, { 
                service: 'estoque_solicitacoes', 
                func: 'store',
                dados: { 
                    id_estoque_solicitacao: this.solic.id_estoque_solicitacao, 
                    id_centro_custo: this.solic.id_centro_custo
                }, 
                toast: true, 
                modal: 'alterarCentroModal', 
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        }, 
        
    }
}
</script>
